export default {
  home: "Inicio",
  explore: "Explorar",
  bookings: "Reservas",
  profile: "Perfil",
  dashboard: "Panel",
  messages: "Mensajes",
  earnings: "Ganancias",

  signOut: "Cerrar sesión",
  save: "Guardar",
  cancel: "Cancelar",
  back: "Atrás",
  loading: "Cargando...",
  submit: "Enviar",
  online: "En línea",
  offline: "Desconectado",

  welcomeBack: "Bienvenido de vuelta",
  elevateSpace: "Eleva tu espacio con Mouna.",
  discovery: "DESCUBRIMIENTO",
  curatedServices: "Servicios Curados",
  allCategories: "Todas las Categorías",
  activeAssignments: "Asignaciones Activas",

  findArtisan: "Encuentra tu artesano.",
  startingFrom: "Desde",
  bookNow: "Reservar ahora",
  proVerified: "PRO VERIFICADO",

  myBookings: "Mis Reservas",
  pending: "pendiente",
  confirmed: "confirmado",
  completed: "completado",
  help: "Ayuda",

  professionalDashboard: "PANEL PROFESIONAL",
  newLeads: "Nuevos Clientes",
  accept: "Aceptar",
  decline: "Rechazar",
  totalEarnings: "GANANCIAS TOTALES",
  leadPricing: "Precios de Clientes",
  myPublicProfile: "Mi Perfil Público",
  portfolio: "Portafolio",
  supportTickets: "Tickets de Soporte",

  requestQuote: "Solicitar Presupuesto",
  jobSize: "Tamaño del Trabajo",
  describeJob: "Describe tu Trabajo",
  serviceAddress: "Dirección del Servicio",
  preferredDate: "Fecha y Hora Preferida",
  sendQuoteRequest: "Enviar Solicitud",
  privateNotes: "Notas Privadas para el Profesional (opcional)",
  addPhotos: "Agregar Fotos o Videos (opcional)",

  howCanWeHelp: "¿Cómo podemos ayudarte?",
  modifyBooking: "Modificar reserva",
  cancelBooking: "Cancelar reserva",
  messageProvider: "Mensaje al proveedor",
  issueWithService: "Problema con el servicio",
  billingIssue: "Problema de facturación",

  signIn: "Iniciar sesión",
  signUp: "Registrarse",
  email: "Correo electrónico",
  password: "Contraseña",
  noAccount: "¿Sin cuenta? Regístrate",
  haveAccount: "¿Tienes cuenta? Inicia sesión",

  leaveReview: "Dejar una Reseña",
  submitReview: "Enviar Reseña",
  respond: "Responder",

  contactSupport: "Contactar Soporte",
  myTickets: "Mis Tickets de Soporte",
  getHelp: "Obtener Ayuda",
};
